import _ from 'underscore';
import { CWBaseModel } from 'core/models/cwBase.model';


export class CWLastBadgeModel extends CWBaseModel {

  matricule: string;

  defaults(): { [key: string]: any } {
    return {
      dervalide: null,
      derheure: "",
      derlibelle: "",
      derdate: ""
    }
  }

  constructor(attributes?: { [key: string]: any } | any, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(attributes)) {
      options = attributes;
    }
    options = options || {};
    super(attributes, options);
    if (options && options.matricule) {
      this.matricule = options.matricule;
    }
    this.url = (): string => {
      return Configuration.restRoot + "/rest/badgvirtuel/" + this.matricule;
    }
  }
}